import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  FormControl,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  HStack,
  Flex,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { FaSync, FaPrint } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const View_Homework = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const userid = sessionStorage.getItem("user_id");
  const toast = useToast();

  // Fetch classes and subjects
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        setClasses(response.data.data || []);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/subject/list_subject.php`
        );
        setSubjects(response.data.data || []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchClasses();
    fetchSubjects();
  }, []);

  // Fetch homework based on new API
  useEffect(() => {
    const fetchHomework = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/student/homework/list_homework.php`,
          { pass: userid } // This is assuming the new API takes 'pass' in the payload
        );
        console.log("home",response);
        
        if (response.data.success) {
          setFilteredMaterials(response.data.data || []);
        } else {
          setFilteredMaterials([]);
          toast({
            title: "Error",
            description: response.data.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error(
          "Error fetching homework:",
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchHomework();
  }, [userid, toast]);

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
  };

  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };

  // Pagination Logic
  const totalPages = Math.ceil(filteredMaterials.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredMaterials.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pages.push(i);
        }
      }
    }
    return pages;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px" }}>Homework</h1>
          </div>

          <div className="breadcrumb">
            <span>Student</span> / <span>Course Material</span> /{" "}
            <span>Homework</span>
          </div>
        </div>
        <Box p={6}>
        <Flex
          mt={6}
          justifyContent="space-between"
          alignItems="center"
          className="sb"
          p={3}
        >
          <FormControl id="class" width="48%">
            <Select
              placeholder="Select Class"
              value={selectedClass}
              onChange={handleClassChange}
            >
              {classes.map((cls) => (
                <option key={cls.id} value={cls.id}>
                  {cls.class}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl id="subject" width="48%">
            <Select
              placeholder="Select Subject"
              value={selectedSubject}
              onChange={handleSubjectChange}
            >
              {subjects.map((subject) => (
                <option key={subject.subject_id} value={subject.subject_id}>
                  {subject.subject}
                </option>
              ))}
            </Select>
          </FormControl>
        </Flex>
        <Box overflowX="auto" maxWidth="100%">
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
            <Thead>
              <Tr>
                <Th>Class</Th>
                <Th>Subject</Th>
                <Th>Caption</Th>
                <Th>Description</Th>
                <Th>Homework File</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((material) => (
                  <Tr key={material.id}>
                    <Td>{material.class_id || "N/A"}</Td>
                    <Td>{material.subject_id || "N/A"}</Td>
                    <Td>{material.title || "N/A"}</Td>
                    <Td>{material.description || "N/A"}</Td>
                    <Td>
                      {material.attachment_url ? (
                        <a
                          href={material.attachment_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View File
                        </a>
                      ) : (
                        "No File"
                      )}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="5">
                    <Text textAlign="center">No homework available</Text>
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>

        <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {getPageNumbers().map((pageNum) => (
              <Button
                key={pageNum}
                onClick={() => handlePageChange(pageNum)}
                backgroundColor={currentPage === pageNum ? "teal" : "gray.100"}
                color={currentPage === pageNum ? "white" : "black"}
              >
                {pageNum}
              </Button>
            ))}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
        </Box>
      </div>
    </Box>
  );
};

export default View_Homework;
